import { HostBinding, Component, OnInit, Injector } from '@angular/core';
import { EventsComponent } from '../events/events.component';
import { includes, filter, isEmpty } from 'lodash';

@Component({
	selector: 'multi-checkbox',
	host: { '[class]': 'myCustomClass' },
	template: `
		<label
			*ngFor="let option of control.options"
			[ngClass]="{ error: error, disabled: control.disabled }"
			role="checkbox"
			[attr.id]="labelId"
			[attr.aria-checked]="isSelected[option.value]"
			[tabindex]="control.disabled ? -1 : 0"
			(keypress)="onKeyPress(option.value, $event)"
		>
			<input
				gtm-handler
				[attr.gtm]="option.value"
				events="change"
				handlerType="checkbox"
				[label]="option.value"
				action="BoxCheck"
				[checked]="isSelected[option.value]"
				type="checkbox"
				[attr.id]="option.value.split('.').join('_')"
				(change)="onToggle(option.value)"
				class="custom-checkbox-input"
				[disabled]="control.disabled"
			/>

			<span class="custom-input"></span>

			<div class="custom-checkbox-title">
				{{ option.title }}
			</div>
		</label>
	`,
	styleUrls: ['./multi-checkbox.component.scss'],
})
export class MultiCheckboxComponent extends EventsComponent implements OnInit {
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	multiValue: any[];
	labelId: string;
	isSelected: any = {};

	constructor(injector: Injector) {
		super(injector);
	}

	async ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		this.labelId = this.name + '_label';
		if (this.value && this.value.length) {
			this.reportPrefill();
		}
		this.control.options.forEach((opt) => {
			this.isSelected[opt.value] = includes(this.value, opt.value);
		});
	}

	onKeyPress(value, event) {
		if (event.keyCode === 13 || event.keyCode === 32) {
			this.onToggle(value);

			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
		}
	}

	onToggle(value) {
		if (this.control.disabled) {
			return;
		}
		// when remove
		if (this.isSelected[value]) {
			this.remove(value);
			this.reportEditedPrefillValue();
			return;
		}
		// when add
		this.add(value);
		this.reportEditedPrefillValue();
	}

	add(value) {
		if (!this.value) {
			this.value = [];
			this.setAnswer([]);
		}

		// wait for digest to finish so this.value will be properly fetched from Store
		setTimeout(() => {
			// do not setAnswer if conditions aren't met
			if (this.value.length >= this.control.attributes.maxLength || includes(this.value, value)) {
				return;
			}

			this.setAnswer([...this.value, value]);
			this.value = [...this.value, value];
			this.isSelected[value] = includes(this.value, value);
		}, 0);
	}

	remove(value) {
		let ans = filter(this.value, (o) => o !== value);
		ans = isEmpty(ans) ? null : ans;
		this.setAnswer(ans);
		this.value = ans;
		this.isSelected[value] = includes(this.value, value);
	}
}
